<template>
  <div class="homepage-header">
    <template v-if="editing">
      <!-- 编辑态头部 -->
      <div class="homepage-header-nav editing">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="8"><span @click="cancelEditing">取消</span></el-col>
          <el-col :span="8" class="text-center"><span class="title">编辑主页</span></el-col>
          <el-col :span="8" class="text-right"><el-button type="primary" size="small" @click="saveEditing">保存</el-button></el-col>
        </el-row>
      </div>
    </template>
    <template v-else>
      <!-- 汉堡菜单头部 -->
      <div class="homepage-header-nav">
        <router-link to="/homepage_m">
          <i class="iconfont icon--logo"></i>
        </router-link>
        <template v-if="loginUser">
          <span
            class="iconfont pull-right"
            :class="[scholarHomepageContent ? 'icon--close' : 'icon--menu']"
            @click="scholarHomepageContent = !scholarHomepageContent">
          </span>
        </template>
        <template v-else>
          <span @click="showChatCode" class="pull-right">登录/注册</span>
        </template>
      </div>
      <!-- 汉堡菜单内容 -->
      <el-collapse-transition v-if="loginUser">
        <div v-show="scholarHomepageContent" class="foldable-menu-content" id="foldable_menu_content">
          <template v-if="loginUser.is_self == 1">
            <p @click="entryEditing">
              <i class="iconfont icon--intro"></i>编辑主页
            </p>
          </template>
          <template v-else>
            <p @click="myHomePage">
              <i class="iconfont icon--intro"></i>我的主页
            </p>
          </template>
          <p @click="linkToApp">
            <i class="iconfont icon--papers"></i>管理成果
          </p>
        </div>
      </el-collapse-transition>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    loginUser: Object,
    editing: Boolean
  },
  data () {
    return {
      scholarHomepageContent: false,
      myHomepageVisible: true,
      editHomepageVisible: false
    }
  },
  created () {
    document.addEventListener('click', (e) => {
      var container = document.getElementById('foldable_menu_content')
      if (container) {
        if (!container.contains(event.target) &&
            event.target.className !== 'iconfont pull-right icon--menu' &&
            this.scholarHomepageContent) {
          this.scholarHomepageContent = false
        }
      }
    })
  },
  methods: {
    myHomePage () {
      if (this.loginUser.homepage_uid > 0) {
        window.location.href = `${window.location.origin}/${this.loginUser.id}`
      } else {
        this.$emit('createScholar')
      }
    },
    linkToApp () {
      window.location.href = 'http://sj.qq.com/myapp/detail.htm?apkName=com.quickwis.academe'
    },
    entryEditing () {
      this.scholarHomepageContent = false
      this.$emit('entryEditing', true)
    },
    cancelEditing () {
      this.$emit('cancelEditing')
    },
    saveEditing () {
      this.$emit('saveEditing')
    },
    showChatCode () {
      this.$emit('wxAuthorize')
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/HeaderMobile/index.vue